import Axios from 'axios'
import Moment from 'moment'

import { getCookie } from '../utils/auth-utils'
import strings from '../strings'

const resultPDF = {
  axios() {
    let AxiosInstance = Axios.create({
      baseURL: process.env.ORDER_API_V2,
      headers: {
        Authorization: strings.headers.bearerAuthentication + getCookie('token_aol'),
      },
    })
    return AxiosInstance
  },
  axiosExternalURL() {
    let AxiosInstance = Axios.create({
      baseURL: process.env.LAUDOS_API,
      headers: {
        Authorization: strings.headers.bearerAuthentication + getCookie('token_aol'),
      },
    })

    return AxiosInstance
  },
  getResultsPDFByFilter(data) {
    const filters = {
      namePatient: data && data.namePatient ? `&namePatient=${data.namePatient}` : '',
      alvaroId: data && data.alvaroId ? `&alvaroId=${data.alvaroId}` : '',
      lisId: data && data.lisId ? `&lisId=${data.lisId}` : '',
      mnemonic: data && data.mnemonic ? `&mnemonic=${data.mnemonic}` : '',
      examFilter: data && data.examFilter ? `&examFilter=${data.examFilter}` : '',
      osWithAllExamsFinished:
        data && data.osWithAllExamsFinished
          ? `&osWithAllExamsFinished=${data.osWithAllExamsFinished}`
          : '',
      byResultDate: data && data.byResultDate ? `&byResultDate=${data.byResultDate}` : '',
      transferDateFrom:
        data && data.transferDateFrom
          ? `&transferDateFrom=${this.convertDataInTimeStamp(data.transferDateFrom)}`
          : '',
      transferDateTo:
        data && data.transferDateTo
          ? `&transferDateTo=${this.convertDataInTimeStamp(data.transferDateTo, true)}`
          : '',
      page: (data && data.page) || 1,
    }

    return this.axios().get(
      `/orders/${getCookie('profile').id_laboratory}/orders/exams?page=${filters.page}${filters.namePatient}${
        filters.alvaroId
      }${filters.examFilter}${filters.osWithAllExamsFinished}${filters.lisId}${filters.byResultDate}${
        filters.transferDateFrom
      }${filters.transferDateTo}${filters.mnemonic}`
    )
  },
  getPrintConfig() {
    return this.axios().get(
      `laudo/config?idEntidade=${getCookie('profile').id_laboratory}`
    )
  },
  savePrintConfig(configData) {
    return this.axios().put(`laudo/config`, configData)
  },
  downloadResultsPDF(os, exams, isPaternity = false) {
    const byExam = exams && exams.length > 0 ? ':' + exams : ''
    const endpoint = isPaternity ? 'laudos/paternity/pdf' : 'laudos/pdf'
    return this.axiosExternalURL().get(`${endpoint}?id=${os}${byExam}`, {
      responseType: 'arraybuffer',
    })
  },
  downloadResultsHTML(os, exams, isPaternity = false) {
    const byExam = exams && exams.length > 0 ? ':' + exams : ''
    const endpoint = isPaternity ? 'laudos/paternity/html' : 'laudos/html'
    return this.axiosExternalURL().get(`${endpoint}?id=${os}${byExam}`)
  },
  validateResults(token, recaptchaToken) {
    const config = {
      headers: {},
    }

    if (recaptchaToken) {
      config.headers['X-Recaptcha-Token'] = recaptchaToken
    }

    return this.axiosExternalURL().post(`laudos/valida`, { token }, config)
  },
  convertDataInTimeStamp(date, final) {
    const convertedDate = Moment(date, 'DD/MM/YYYY')
    if (final) {
      const timestampFinal = convertedDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      return timestampFinal
    } else {
      const timestamp = convertedDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      return timestamp
    }
  },
}

export default resultPDF
